/** @jsx jsx */
import { Box, Flex, Heading, Link, jsx } from 'theme-ui'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import FacebookIcon from '~/assets/images/icons/facebook.inline.svg'
import InstagramIcon from '~/assets/images/icons/instagram.inline.svg'
import TwitterIcon from '~/assets/images/icons/twitter.inline.svg'
import useSiteMetadataQuery from '~/hooks/graphql/queries/use-site-metadata'

const FooterSocialButton = ({ children, ...props }) => {
  return (
    <Link
      {...props}
      sx={{
        color: 'white',
        height: '32px',
        width: '32px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mr: 5,
        ':last-child': {
          mr: 0,
        },
        '& > svg': {
          height: '32px',
          width: 'auto',
        },
      }}
    >
      {children}
    </Link>
  )
}

const FooterSocial = () => {
  const { site } = useSiteMetadataQuery()
  const translate = useTranslate()

  const { facebook, instagram, twitter } = site.siteMetadata.social

  return (
    <Box>
      <Heading as="h2" variant="title5" sx={{ mb: 3 }}>
        {translate('footer.social.title')}
      </Heading>
      <Flex sx={{ justifyContent: 'left' }}>
        <FooterSocialButton
          href={`https://www.facebook.com/${facebook}`}
          target="_blank"
          title="Visit our Facebook page (opens in a new window)"
          rel="noreferrer"
        >
          <FacebookIcon />
        </FooterSocialButton>
        <FooterSocialButton
          href={`https://www.instagram.com/${instagram}`}
          target="_blank"
          title="Visit our Instagram page (opens in a new window)"
          rel="noreferrer"
        >
          <InstagramIcon />
        </FooterSocialButton>
        <FooterSocialButton
          href={`https://www.twitter.com/${twitter}`}
          target="_blank"
          title="Visit our Twitter page (opens in a new window)"
          rel="noreferrer"
        >
          <TwitterIcon />
        </FooterSocialButton>
      </Flex>
    </Box>
  )
}

export default FooterSocial
